import { CognitoUser } from 'amazon-cognito-identity-js';
import { AuthAction, AuthResult, CognitoError } from './types';
import { wrapError } from '.';

/**
 * Attempts to reset the user's password using the old and new password
 * @param oldPassword - the old password
 * @param newPassword - the new password
 */

export const cognitoChangePassword = async (
  oldPassword: string,
  newPassword: string,
  cognitoUser: CognitoUser,
  dispatch: React.Dispatch<AuthAction>,
): Promise<AuthResult> => {
  return new Promise((resolve, reject) => {
    const fallbackErrMessage = 'Error occurred while attempting to change password';
    try {
      cognitoUser.changePassword(oldPassword, newPassword, (err: Error | undefined) => {
        if (err) {
          const cognitoErr = err as CognitoError;
          dispatch({ type: 'setFeedback', payload: `${cognitoErr.message} (${cognitoErr.code})` });
          reject({
            error: wrapError(cognitoErr, fallbackErrMessage),
            message: 'Error: unable to change password',
            complete: false,
          });
        } else {
          dispatch({ type: 'setFeedback', payload: 'password changed' });
          resolve({ error: undefined, message: 'Success: password changed', complete: true });
        }
      });
    } catch (err) {
      const error = err as Error;
      dispatch({ type: 'setFeedback', payload: error.message });
      reject({
        error: wrapError(error, fallbackErrMessage),
        message: 'Error: unable to change password',
        complete: false,
      });
    }
  });
};
